import type { DefineLocaleMessage } from "vue-i18n";

export type AppLocale = "en" | "es" | "vi" | "zh";

// Lazy loaders: mỗi locale là 1 dynamic import → Vite code-split thành chunk riêng,
// chỉ tải locale đang dùng (các locale khác load on-demand khi đổi ngôn ngữ).
const localeLoaders = {
  en: () => import("./en"),
  es: () => import("./es"),
  vi: () => import("./vi"),
  zh: () => import("./zh"),
} satisfies Record<AppLocale, () => Promise<unknown>>;

export const isSupportedLocale = (
  locale: string | null | undefined,
): locale is AppLocale => !!locale && locale in localeLoaders;

export async function loadLocaleMessages(
  locale: AppLocale,
): Promise<DefineLocaleMessage> {
  const loader = localeLoaders[locale] ?? localeLoaders.en;
  // Cast qua `unknown`: shape của module (object literal lồng nhau) không khớp
  // trực tiếp kiểu `DefineLocaleMessage` (index-signature) của vue-i18n, dù
  // runtime là hợp lệ — nên cần bridge `unknown`.
  const mod = (await loader()) as unknown as { default: DefineLocaleMessage };
  return mod.default;
}
